// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editable-text-input{background-color:#f1f8fd;transition:padding-left 0.25s ease;padding-left:0px;color:#354b53;min-height:36px;padding:8px}.editable-text-input:focus{color:#354b53;background-color:#FAFAFC !important;border:0.5px solid #CACCCE}.editable-text-input:hover{background-color:#FAFAFC}.editable-text-input--error .bp3-editable-text-content,.editable-text-input--error .bp3-editable-text-input{color:#DD524C}.editable-text-input--disabled{cursor:default}\n", ""]);
// Exports
module.exports = exports;
